import React from 'react';
import PropTypes from 'prop-types';

function ErrorComponent({ title, errorObject, message }) {

    if(!message) {
        message = 'Une erreur inconnue est survenue. Veuillez réessayer plus tard.';
    }

    if (errorObject && errorObject.code === 'ERR_NETWORK') {
        if (!navigator.onLine) {
            message =
                'Une erreur réseau est survenue. Veuillez vérifier votre connexion internet et réessayer.';
        }
    }
    return (
        <div className="container">
            <p className="title">{title}</p>

            <p>{message}</p>
        </div>
    );
}

// Prop types for the Error component
ErrorComponent.propTypes = {
    title: PropTypes.string.isRequired,
    errorObject: PropTypes.object,
    message: PropTypes.string,
};

export default ErrorComponent;
